import owd from 'owd/owd';

export default class Fields extends owd.Component {
	init() {
		this.$items = this.$element.find('[data-fields-item]');
		this.$closes = this.$element.find('[data-fields-close]');

        this.bind();
	}

	bind() {
		this.on('click', this.$items, (e) => {
			this.$items.removeClass('is-active');
			$(e.currentTarget).addClass('is-active');
		})

		this.on('click', this.$closes, (e) => {
			e.stopPropagation();

			this.$items.removeClass('is-active');
		})
	}

	destroy() {
		super.destroy();
	}
}

owd.registerComponent('fields', {
	component: Fields
});
